import { SINGLE_PAGE_VIEW_CONTEXT } from '../constants';
import { ExtractionSpecType } from '../types';

export const getPageExtractions = (page: number, extractionsSpecs: ExtractionSpecType[]): ExtractionSpecType[] => {
    return extractionsSpecs.filter((extraction) => extraction.page === page);
};

export const getContextPages = (pageNumber: number): number[] => {
    const contextPages: number[] = [];
    for (let page = pageNumber - SINGLE_PAGE_VIEW_CONTEXT; page <= pageNumber + SINGLE_PAGE_VIEW_CONTEXT; page++) {
        contextPages.push(page);
    }

    return contextPages;
};
